export default __webpack_public_path__ + "static/media/chat.78dd2e8d.svg";